/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignDetailResponseSchema } from '../campaign-schema';

export const getCampaignPathSchema = z.object({ campaignId: z.string() });

export const getCampaignOperationResponseSchema = campaignDetailResponseSchema;

export type GetCampaignInput = {
  path: z.input<typeof getCampaignPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaign({
  path,
  signal,
}: GetCampaignInput): Promise<
  z.infer<typeof getCampaignOperationResponseSchema>
> {
  const parsedPath = getCampaignPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}`,
    {
      signal,
    },
  );
  return getCampaignOperationResponseSchema.parse(await response.json());
}
